import { Logger } from './abstractLogger';

class ProductionLogger extends Logger {
  // eslint-disable-next-line @typescript-eslint/no-empty-function, class-methods-use-this
  log(): void {}
  // eslint-disable-next-line @typescript-eslint/no-empty-function, class-methods-use-this
  error(): void {}
  // eslint-disable-next-line @typescript-eslint/no-empty-function, class-methods-use-this
  success(): void {}
}

export default ProductionLogger;
